module.exports = __webpack_public_path__ + "static/media/1.e83fe259.svg";